/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Casemanagement_Description1Inputs */

const en_settings_casemanagement_description1 = /** @type {(inputs: Settings_Casemanagement_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Define the categories cases are classified into and the service-level targets they are measured against.`)
};

/**
* | output |
* | --- |
* | "Define the categories cases are classified into and the service-level targets they are measured against." |
*
* @param {Settings_Casemanagement_Description1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const settings_casemanagement_description1 = /** @type {((inputs?: Settings_Casemanagement_Description1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Casemanagement_Description1Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_settings_casemanagement_description1(inputs)
});
export { settings_casemanagement_description1 as "settings_caseManagement_description" }